"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _reactRedux = require("react-redux");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _UITooltip = _interopRequireDefault(require("UIComponents/tooltip/UITooltip"));

var _propTypes2 = require("../../constants/propTypes");

var _Permissions = require("../../selectors/Permissions");

var _notifications = require("../../utils/notifications");

var ScopedFeatureTooltip = function ScopedFeatureTooltip(props) {
  var readOnlyReason = props.readOnlyReason,
      children = props.children,
      titleOverride = props.titleOverride,
      rest = (0, _objectWithoutProperties2.default)(props, ["readOnlyReason", "children", "titleOverride"]);
  var title;
  var disabled = !readOnlyReason;

  if (readOnlyReason) {
    title = (0, _notifications.getReadOnlyPermissionMessaging)(readOnlyReason).explanation;
  } else if (titleOverride) {
    title = titleOverride;
    disabled = false;
  }

  return _react.default.createElement(_UITooltip.default, Object.assign({
    title: title,
    disabled: disabled,
    "data-test-read-only-reason": readOnlyReason
  }, rest), children);
};

ScopedFeatureTooltip.propTypes = {
  children: _propTypes.default.node.isRequired,
  titleOverride: _propTypes.default.node,
  readOnlyReason: _propTypes2.readOnlyReasonProp
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    readOnlyReason: (0, _Permissions.getReadOnlyReason)(state)
  };
};

var _default = (0, _reactRedux.connect)(mapStateToProps, {})(ScopedFeatureTooltip);

exports.default = _default;
module.exports = exports.default;